export const KEY_CODE_BREAK = 3
export const KEY_CODE_BACKSPACE = 8
export const KEY_CODE_TAB = 9
export const KEY_CODE_CLEAR = 12
export const KEY_CODE_ENTER = 13
export const KEY_CODE_SHIFT = 16
export const KEY_CODE_CTRL = 17
export const KEY_CODE_ALT = 18
export const KEY_CODE_PAUSE_BREAK = 19
export const KEY_CODE_CAPS_LOCK = 20
export const KEY_CODE_HANGUL = 21
export const KEY_CODE_HANJA = 25
export const KEY_CODE_ESCAPE = 27
export const KEY_CODE_CONVERSION = 28
export const KEY_CODE_NON_CONVERSION = 29
export const KEY_CODE_SPACEBAR = 32
export const KEY_CODE_PAGE_UP = 33
export const KEY_CODE_PAGE_DOWN = 34
export const KEY_CODE_END = 35
export const KEY_CODE_HOME = 36
export const KEY_CODE_LEFT_ARROW = 37
export const KEY_CODE_UP_ARROW = 38
export const KEY_CODE_RIGHT_ARROW = 39
export const KEY_CODE_DOWN_ARROW = 40
export const KEY_CODE_SELECT = 41
export const KEY_CODE_PRINT = 42
export const KEY_CODE_EXECUTE = 43
export const KEY_CODE_PRINT_SCREEN = 44
export const KEY_CODE_INSERT = 45
export const KEY_CODE_DELETE = 46
export const KEY_CODE_HELP = 47
export const KEY_CODE_0 = 48
export const KEY_CODE_1 = 49
export const KEY_CODE_2 = 50
export const KEY_CODE_3 = 51
export const KEY_CODE_4 = 52
export const KEY_CODE_5 = 53
export const KEY_CODE_6 = 54
export const KEY_CODE_7 = 55
export const KEY_CODE_8 = 56
export const KEY_CODE_9 = 57
export const KEY_CODE_COLON = 58
export const KEY_CODE_FIREFOX_SEMICOLON = 59
export const KEY_CODE_EQUALS = 59
export const KEY_CODE_LESS_THAN = 60
export const KEY_CODE_FIREFOX_EQUALS = 61
export const KEY_CODE_SS = 63
export const KEY_CODE_FIREFOX_AT_SIGN = 64
export const KEY_CODE_A = 65
export const KEY_CODE_B = 66
export const KEY_CODE_C = 67
export const KEY_CODE_D = 68
export const KEY_CODE_E = 69
export const KEY_CODE_F = 70
export const KEY_CODE_G = 71
export const KEY_CODE_H = 72
export const KEY_CODE_I = 73
export const KEY_CODE_J = 74
export const KEY_CODE_K = 75
export const KEY_CODE_L = 76
export const KEY_CODE_M = 77
export const KEY_CODE_N = 78
export const KEY_CODE_O = 79
export const KEY_CODE_P = 80
export const KEY_CODE_Q = 81
export const KEY_CODE_R = 82
export const KEY_CODE_S = 83
export const KEY_CODE_T = 84
export const KEY_CODE_U = 85
export const KEY_CODE_V = 86
export const KEY_CODE_W = 87
export const KEY_CODE_X = 88
export const KEY_CODE_Y = 89
export const KEY_CODE_Z = 90
export const KEY_CODE_LEFT_WINDOW_KEY = 91
export const KEY_CODE_RIGHT_WINDOW_KEY = 92
export const KEY_CODE_CMD = 93
export const KEY_CODE_SLEEP = 95
export const KEY_CODE_NUMPAD_0 = 96
export const KEY_CODE_NUMPAD_1 = 97
export const KEY_CODE_NUMPAD_2 = 98
export const KEY_CODE_NUMPAD_3 = 99
export const KEY_CODE_NUMPAD_4 = 100
export const KEY_CODE_NUMPAD_5 = 101
export const KEY_CODE_NUMPAD_6 = 102
export const KEY_CODE_NUMPAD_7 = 103
export const KEY_CODE_NUMPAD_8 = 104
export const KEY_CODE_NUMPAD_9 = 105
export const KEY_CODE_MULTIPLY = 106
export const KEY_CODE_ADD = 107
export const KEY_CODE_FIREFOX_NUMPAD_PERIOD = 108
export const KEY_CODE_SUBTRACT = 109
export const KEY_CODE_DECIMAL_POINT = 110
export const KEY_CODE_DIVIDE = 111
export const KEY_CODE_F1 = 112
export const KEY_CODE_F2 = 113
export const KEY_CODE_F3 = 114
export const KEY_CODE_F4 = 115
export const KEY_CODE_F5 = 116
export const KEY_CODE_F6 = 117
export const KEY_CODE_F7 = 118
export const KEY_CODE_F8 = 119
export const KEY_CODE_F9 = 120
export const KEY_CODE_F10 = 121
export const KEY_CODE_F11 = 122
export const KEY_CODE_F12 = 123
export const KEY_CODE_F13 = 124
export const KEY_CODE_F14 = 125
export const KEY_CODE_F15 = 126
export const KEY_CODE_F16 = 127
export const KEY_CODE_F17 = 128
export const KEY_CODE_F18 = 129
export const KEY_CODE_F19 = 130
export const KEY_CODE_F20 = 131
export const KEY_CODE_F21 = 132
export const KEY_CODE_F22 = 133
export const KEY_CODE_F23 = 134
export const KEY_CODE_F24 = 135
export const KEY_CODE_F25 = 136
export const KEY_CODE_F26 = 137
export const KEY_CODE_F27 = 138
export const KEY_CODE_F28 = 139
export const KEY_CODE_F29 = 140
export const KEY_CODE_F30 = 141
export const KEY_CODE_F31 = 142
export const KEY_CODE_F32 = 143
export const KEY_CODE_NUM_LOCK = 144
export const KEY_CODE_SCROLL_LOCK = 145
export const KEY_CODE_AIRPLANE_MODE = 151
export const KEY_CODE_CARET = 160
export const KEY_CODE_EXCLAMATION = 161
export const KEY_CODE_ARABIC_SEMICOLON = 162
export const KEY_CODE_POUND_SIGN = 163
export const KEY_CODE_DOLLAR_SIGN = 164
export const KEY_CODE_Ù = 165
export const KEY_CODE_PAGE_BACKWARD = 166
export const KEY_CODE_PAGE_FORWARD = 167
export const KEY_CODE_REFRESH = 168
export const KEY_CODE_CLOSING_PAREN = 169
export const KEY_CODE_ASTERISK = 170
export const KEY_CODE_HOME_KEY = 172
export const KEY_CODE_NEXT = 176
export const KEY_CODE_PREVIOUS = 177
export const KEY_CODE_STOP = 178
export const KEY_CODE_PLAY_PAUSE = 179
export const KEY_CODE_EMAIL = 180
export const KEY_CODE_SEMI_COLON = 186
export const KEY_CODE_EQUAL_SIGN = 187
export const KEY_CODE_COMMA = 188
export const KEY_CODE_DASH = 189
export const KEY_CODE_PERIOD = 190
export const KEY_CODE_QUESTION = 191
export const KEY_CODE_SLASH = 191
